import Account from '@/app/views/Account.vue';

export const childRoutes = [
  {
    path: '',
    name: 'account-details',
    redirect: '/account/profile', // Redirect /account to /accout/profile based on new route structure in NWP-28 Multi User Accounts
  },
  {
    path: 'profile',
    name: 'account-profile',
    component: () => import(/* webpackChunkName: "info" */ '@/app/views/account/Profile.vue'),
    meta: {
      new: false, display: 'Profile', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT',
    },
  },
  {
    path: 'billing',
    name: 'account-billing',
    component: () => import(/* webpackChunkName: "info" */ '@/app/views/account/Billing.vue'),
    meta: {
      new: false, display: 'Billing', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT', permission: 'OWNER',
    },
  },
  {
    path: 'courses',
    name: 'account-courses',
    component: () => import(/* webpackChunkName: "info" */ '@/app/views/account/Courses.vue'),
    meta: {
      requiresPermission: true, app: 'ACCOUNT_MANAGEMENT',
    },
  },
  {
    path: 'users',
    name: 'account-users',
    component: () => import(/* webpackChunkName: "info" */ '@/app/views/account/Users.vue'),
    meta: {
      new: false, display: 'Users', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT', permission: 'OWNER',
    },
  },
  {
    path: 'integrations',
    name: 'account-user-integrations',
    component: () => import(/* webpackChunkName: "info" */ '@/app/views/account/Integrations.vue'),
    meta: {
      new: false, display: 'Integrations', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT',
    },
  },
  {
    path: 'subscribe',
    name: 'subscribe',
    redirect: '/account',
    component: () => import(/* webpackChunkName: "subscribe" */ '@/app/views/account/Subscribe.vue'),
    meta: { display: 'Subscribe', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT' },
    children: [
      {
        path: 'welcome',
        name: 'subscribe-welcome',
        component: () => import(/* webpackChunkName: "subscribe-product" */ '@/app/views/account/subscribe/SubscribeWelcome.vue'),
        meta: { display: 'Subscribe', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT' },
        props: route => ({ product: route.query.product }),
      },
      {
        path: ':product',
        name: 'subscribe-product',
        component: () => import(/* webpackChunkName: "subscribe-product" */ '@/app/views/account/subscribe/SubscribeProduct.vue'),
        meta: { display: 'Subscribe', requiresPermission: true, app: 'ACCOUNT_MANAGEMENT' },
        props: true,
      },
    ],
  },
];

export default {
  path: '/account',
  component: Account,
  meta: {
    requiresAuth: true, refreshAccount: true, requiresPermission: true, app: 'ACCOUNT_MANAGEMENT',
  },
  children: childRoutes,
};
